import { NavLink } from 'react-router-dom';
import { ClipboardList, CreditCard, PackageCheck, RefreshCw, Settings2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ServicePageHeader } from './DocumentServicesCommon';

const tabs = [
  { label: 'Orders', path: '/admin/document-services/orders', icon: ClipboardList },
  { label: 'Products & Services', path: '/admin/document-services/products', icon: Settings2 },
  { label: 'Payments', path: '/admin/document-services/payments', icon: CreditCard },
  { label: 'Fulfillment', path: '/admin/document-services/fulfillment', icon: PackageCheck },
  { label: 'Reconciliation', path: '/admin/document-services/reconciliation', icon: RefreshCw },
];

export default function AdminDocumentServicesHeader({ title, description, actions }) {
  return (
    <div className="space-y-5">
      <ServicePageHeader eyebrow="Finance · Document Services" title={title} description={description} actions={actions} />
      <nav aria-label="Document Services administration" className="overflow-x-auto rounded-xl border border-[#062B1A]/8 bg-white p-1 shadow-sm">
        <div className="flex min-w-max gap-1">
          {tabs.map((tab) => <NavLink key={tab.path} to={tab.path} className={({ isActive }) => cn('inline-flex items-center rounded-lg px-3 py-2 text-sm font-medium transition-colors', isActive ? 'bg-[#062B1A] text-white' : 'text-[#062B1A]/60 hover:bg-[#062B1A]/5 hover:text-[#062B1A]')}><tab.icon className="mr-2 size-4" />{tab.label}</NavLink>)}
        </div>
      </nav>
    </div>
  );
}
